// extracted by mini-css-extract-plugin
module.exports = {"iconMainImage":"ImageDetailModal_iconMainImage__3siZO"};